module.exports = __webpack_public_path__ + "static/media/PM44.98f99fa4.JPG";